import { createElement } from "react";
import { t } from "../Lang.js";
import { Common_loading } from "../Shared/Tr.js";

/**
 * Loading spinner
 */
export function spinner() {
    return createElement("div", {
        className: "spinner",
        children: t(Common_loading),
    });
}

/**
 * Error message
 */
export function errorMessage(msg) {
    return createElement("div", {
        className: "error-message",
        children: msg,
    });
}

